import { useState } from 'react';

const PAGE_SIZE_KEY = 'workflow-admin-page-size';
const DEFAULT_PAGE_SIZE = 25;

export const usePageSize = () => {
  const [pageSize, setPageSizeState] = useState<number>(() => {
    const saved = localStorage.getItem(PAGE_SIZE_KEY);
    return saved ? parseInt(saved, 10) : DEFAULT_PAGE_SIZE;
  });

  const setPageSize = (newSize: number) => {
    setPageSizeState(newSize);
    localStorage.setItem(PAGE_SIZE_KEY, newSize.toString());
  };

  return { pageSize, setPageSize };
};
